import { Dialog, Fade, Menu, MenuItem } from '@material-ui/core';
import { useVerifyAction } from '@vadiun/react-hooks-legacy';
import ExtendExcessModal from 'app/chofer/components/ExtendExcessModal';
import {
  ChoferTrabajandoExtendedPayload
} from 'app/chofer/models/ChoferTrabajando';
import { DriverShiftsExceeded } from 'app/chofer/models/DriverShift';
import React, { FC, useEffect, useState } from 'react';
import { useNotificationsContext } from 'shared/context/notificationContext';
import { tw } from 'utils/tailwindUtils';
interface MenuItems {
  label: string;
  driverId: number;
  requestData: DriverShiftsExceeded;
}
interface DriverExtendExcessRequestMenuProps {
  extendExcess: (id: number, payload: ChoferTrabajandoExtendedPayload) => void;
  closeShift: (id: number) => void;
}
const DriverExtendExcessRequestMenu: FC<DriverExtendExcessRequestMenuProps> = ({
  extendExcess,
  closeShift
}) => {
  const verifyAction = useVerifyAction();
  const { driversExceededRequests: exceededRequests, setDriversExceededRequests } =
    useNotificationsContext();
  const { length: sizeDriversExceeded } = exceededRequests || [];
  const hasNotExceeded = sizeDriversExceeded === 0;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [extendExcessModal, setExtendExcessModal] = useState<{
    isOpen: boolean;
    id: number | undefined;
    name: string;
    code: number | undefined;
  }>({ isOpen: false, id: undefined, name: '', code: undefined });

  const menuItems =
    exceededRequests?.map(
      (request, index): MenuItems => ({
        label: `#${request.driverCode} - ${request.driverName}`,
        driverId: request.driverId,
        requestData: request
      })
    ) || [];

  const handleExceededClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onClickExceededItem = (driver: DriverShiftsExceeded) => {
    setExtendExcessModal({ isOpen: true, id: driver.driverId, name: driver.driverName, code: driver.driverCode });
    handleClose(); // Cerramos el menú al seleccionar un ítem
  };

  const clearExtendExcessModal = () => {
    setExtendExcessModal({ isOpen: false, id: undefined, name: '', code: undefined });
  };

  useEffect(() => {
    if (hasNotExceeded) {
      setAnchorEl(null);
    }
  }, [hasNotExceeded]);

  return (
    <>
      <div
        className={tw(
          'flex-1 flex items-center gap-6 justify-between py-0 pl-2 pr-5 rounded-lg duration-500 cursor-pointer hover:bg-gray-100',
          {
            'bg-blue-50': sizeDriversExceeded
          }
        )}
        onClick={hasNotExceeded ? undefined : handleExceededClick}
      >
        <p
          className={tw(
            'duration-500 text-gray-400 text-xs leading-none w-56 flex items-center',
            {
              'text-blue-500': sizeDriversExceeded
            }
          )}
        >
          {sizeDriversExceeded ? (
            <span className="duration-300 relative flex h-3 w-3 mr-2">
              <span className="bg-blue-300 animate-ping absolute inline-flex h-full w-full rounded-full opacity-75"></span>
              <span className="bg-blue-400 relative inline-flex rounded-full h-3 w-3"></span>
            </span>
          ) : (
            <div className="h-3 w-3 ml-2" />
          )}
          Turnos excedidos
        </p>
        <span
          className={tw(
            'text-sm text-gray-700 duration-300 w-6 h-6 rounded-2xl flex justify-center items-center',
            {
              'text-blue-500': sizeDriversExceeded
            }
          )}
        >
          {sizeDriversExceeded}
        </span>
      </div>

      <Menu
        elevation={3}
        id="exceeded-menu"
        anchorEl={anchorEl}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        style={{
          marginLeft: 20,
          marginTop: 40
        }}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
      >
        {menuItems.map((item) => (
          <MenuItem
            key={item.driverId}
            onClick={() => onClickExceededItem(item.requestData)}
            style={{
              height: 30,
              width: 'auto',
              paddingInline: 10
            }}
          >
            <div className="flex w-full justify-between gap-8 text-sm text-gray-400 rounded-md">
              <p>{item.label}</p>
            </div>
          </MenuItem>
        ))}
      </Menu>
      <Dialog
        open={extendExcessModal.isOpen}
        onClose={() =>
          setExtendExcessModal({ isOpen: false, id: undefined, name: '', code: undefined })
        }
        maxWidth="md"
      >
        {extendExcessModal.id && (
          <ExtendExcessModal
            driver={{id: extendExcessModal.id, name: extendExcessModal.name, code: extendExcessModal.code}}
            onSubmit={async (payload: ChoferTrabajandoExtendedPayload) => {
              await extendExcess(extendExcessModal.id!, payload);
              clearExtendExcessModal();
              setDriversExceededRequests([])
            }}
            onCancel={clearExtendExcessModal}
            closeShift={(id) => {
              clearExtendExcessModal();
              verifyAction({
                onAccept: () => closeShift(id),
                body: '¿Está seguro que desea cerrar el turno de este chofer?'
              });
              setDriversExceededRequests([])
            }}
          />
        )}
      </Dialog>
    </>
  );
};

export default DriverExtendExcessRequestMenu;
